







import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export default class BridgeInput extends Vue {
  @Prop({type: String, required: true}) amount!: string
  @Prop({type: String, required: true}) maxAmount!: string
  @Prop({type: Number, required: true}) decimals!: number

  get amountFormatted() {
    return this.amount
  }

  handleKeydown(event: KeyboardEvent) {
    if (this.decimals === 0 && (event.key === '.' || event.key === ',')) {
      event.preventDefault()
    }
  }

  handleInput(event: Event) {
    const element = event.target as HTMLInputElement
    let value = element.value

    if (this.decimals === 0) {
      value = value.replace(/\D/g, '')
    } else {
      value = value.replace(/[^0-9.]/g, '')

      const firstDotIndex = value.indexOf('.')
      if (firstDotIndex !== -1) {
        const beforeDot = value.slice(0, firstDotIndex + 1)
        let afterDot = value.slice(firstDotIndex + 1).replace(/\./g, '')

        if (afterDot.length > this.decimals) {
          afterDot = afterDot.slice(0, this.decimals)
        }

        value = beforeDot + afterDot
      }
    }

    if (value && Number(value) > Number(this.maxAmount)) {
      value = this.maxAmount
    }

    element.value = value
    this.$emit('input', value)
  }
}
